/*** Pre Define Constant Values For Product Listing Api Call Start ***/
// const shopUrl = "https://"+window.Shopify.shop;
// const collectionHandel = "engagement-rings-melbourne";
/*** Pre Define Constant Values For Product Listing Api Call End ***/

/*** Diamond Price Filter End ***/
function getPriceCalibArray(minDiamondPrice,maxDiamondPrice) {
  var price = [];

  for (var i = parseInt(minDiamondPrice); (i < 500 && i<maxDiamondPrice); i = i+10) {
    price.push(i);
  };
  for (var i = 500; (i < 1000 && i<maxDiamondPrice); i = i+15) {
    price.push(i);
  };
  for (var i = 1000; (i < 1500 && i<maxDiamondPrice); i = i+20) {
    price.push(i);
  };
  for (var i = 1500; (i < 2000 && i<maxDiamondPrice); i = i+25) {
    price.push(i);
  };
  for (var i = 2000; (i < 3000 && i<maxDiamondPrice); i = i+30) {
    price.push(i);
  };
  for (var i = 3000; (i < 4000 && i<maxDiamondPrice); i = i+35) {
    price.push(i);
  };
  for (var i = 4000; (i < 4500 && i<maxDiamondPrice); i = i+40) {
    price.push(i);
  };
  for (var i = 4500; (i < 5000 && i<maxDiamondPrice); i = i+45) {
    price.push(i);
  };
  // for (var i = 5000; i < 25000; i = i+50) {
  //   price.push(i);
  // };
  // for (var i = 25000; i < 50000; i = i+100) {
  //   price.push(i);
  // };
  // for (var i = 50000; i < 80000; i = i+200) {
  //   price.push(i);
  // };
  // for (var i = 80000; i < 100000; i = i+1000) {
  //   price.push(i);
  // };
  // for (var i = 100000; i < 200000; i = i+1000) {
  //   price.push(i);
  // };
  
  price.push(parseInt(maxDiamondPrice));
  return price;
}

function get_priceindex(price_min,price_max,value) {
    var price = getPriceCalibArray(price_min,price_max);  
  var pos = 0
  for (i = 0; i < price.length; i++) {
    if (price[i] == value) {
      pos = i;
      break;
    }
  }
  return pos;
}
  
function price_slider_render(min_price,max_price,option,filterLabel){
    var price = getPriceCalibArray(default_price_min,default_price_max);
  
    var minPrice = getClosestNum(min_price,price);
    var maxPrice = getClosestNum(max_price,price);  
    var price_min = get_priceindex(default_price_min,default_price_max,minPrice); 
    var price_max = get_priceindex(default_price_min,default_price_max,maxPrice);   

    //session price filter selected
    var isSelected = false;
    if(min_price != default_price_min || max_price != default_price_max){
       isSelected = true;
    }
    var filterValues = filterLabel+': '+Shopify.formatMoney(min_price*100, theme.moneyFormat)+' - '+Shopify.formatMoney(max_price*100, theme.moneyFormat);   
    setSettingSelectedFilter(filterValues,"price_slider_render('"+default_price_min+"', '"+default_price_max+"','true','"+filterLabel+"')",isSelected,'price');
     //end
   
        jQuery("#tps_price_slider").slider({
            range: true,
            min: 0,
            max: price.length-1,
            values: [ price_min,price_max ],
            step:0.1,
            slide: function( event, ui ) { 
                if ((ui.values[0]) > (ui.values[1])) { 
                    return false; 
                }
                jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
                jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
    
                var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])]*100, theme.moneyFormat);
                price_form = price_form.replace(/([.,]00)$/, '');
                jQuery('#price_from').val(price_form);
                var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])]*100, theme.moneyFormat);
                price_to = price_to.replace(/([.,]00)$/, '');
                jQuery('#price_to').val(price_to);

                option = true;
            },
            change: function(event, ui) {
              var resetFlag = checkResetFlag();
              emptyProductResultDiv();         
              if(option == true) {                         
                 jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
                 jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
                
                 var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])]*100, theme.moneyFormat);
                    price_form = price_form.replace(/([.,]00)$/, '');
                 jQuery('#price_from').val(price_form);
                 var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])]*100, theme.moneyFormat);
                     price_to = price_to.replace(/([.,]00)$/, '');
                 jQuery('#price_to').val(price_to);
                  
                 //applied filters 
                 var isSelected = false;
                 
                 if(price[parseInt(ui.values[0])] != default_price_min || price[parseInt(ui.values[1])] != default_price_max){
                    isSelected = true;
                 }           
                
                 var filterValues = filterLabel+': '+price_form+' - '+price_to;          
                 
                 setSettingSelectedFilter(filterValues,"price_slider_render('"+default_price_min+"', '"+default_price_max+"','true','"+filterLabel+"')",isSelected,'price');

                 updateSessionFilters(session_variable+'-filters',filterLabel, price[parseInt(ui.values[0])]+","+price[parseInt(ui.values[1])]);
                 //end                               

                 if(resetFlag != 'true'){
                    jQuery('#page_no').val(1);
                    jQuery('#pagination').val('');
                    ajaxDataCall();
                 }                 
                 return false;
              }else if(option == false) {
                   jQuery('#price_left_hidden').val(min_price);
                   jQuery('#price_right_hidden').val(max_price);
      
                   var price_form = ""+Shopify.formatMoney(min_price*100, theme.moneyFormat);
                   jQuery('#price_from').val(price_form);
                   var price_to = ""+Shopify.formatMoney(max_price*100, theme.moneyFormat);
                   jQuery('#price_to').val(price_to);

                   updateSessionFilters(session_variable+'-filters',filterLabel, min_price+","+max_price);

                   if(resetFlag != 'true'){
                     jQuery('#page_no').val(1);
                     jQuery('#pagination').val(''); 
                     setTimeout(function(){
                       ajaxDataCall();
                     }, 10);
                   }

                   setTimeout(function(){
                     option = true;
                   }, 25); 
                                      
                   return false;
                }
              slide = '';
            }
             
        });
        
      var start_num = parseInt(min_price);
      var end_num = parseInt(max_price);

      var start_dec = start_num.toFixed(0);
      var end_dec = end_num.toFixed(0);

     jQuery('#price_left_hidden').val(start_dec);
     jQuery('#price_right_hidden').val(end_dec);       
     jQuery('#price_from').val(Shopify.formatMoney(start_dec*100, theme.moneyFormat));  
     jQuery('#price_to').val(Shopify.formatMoney(end_dec*100, theme.moneyFormat));
}


/*** Price Validation Start ***/
$("#price_to").keypress(function(e) {
  //if the letter is not digit then display error and don't type anything
  if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
    return false;
  }
});

$("#price_from").keypress(function(e) {
  //if the letter is not digit then display error and don't type anything
  if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
    return false;
  }
});

// Clear value on focus 
// $(document).on('focus', '#price_from, #price_to', function () {
//   $(this).val('');
// });
// RESTORE value if left empty (delegated)
jQuery(document).on('blur', '#price_from', function () {
  if (jQuery(this).val().trim() === '') {
    var value = jQuery('#price_left_hidden').val();
    jQuery(this).val(
      Shopify.formatMoney(value * 100, theme.moneyFormat).replace(/([.,]00)$/, '')
    );
  }
});

jQuery(document).on('blur', '#price_to', function () {
  if (jQuery(this).val().trim() === '') {
    var value = jQuery('#price_right_hidden').val();
    jQuery(this).val(
      Shopify.formatMoney(value * 100, theme.moneyFormat).replace(/([.,]00)$/, '')
    );
  }
});
/*** Price Validation End ***/

function replace_price_from(ele,priceMin,filterLabel) {   
  if (jQuery('#price_from').val() == '') {
    var value = parseFloat(jQuery('#price_left_hidden').val());          
        var formatted_max_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
    jQuery('#price_from').val(formatted_max_price);
    return false;
  } else {
    var price_min = jQuery('#price_from').val();
  }
  
    var price_min_value = parseInt(getPriceWithoutSymbolAndCommas(price_min));
  var price_max_value = parseInt(jQuery('#price_right_hidden').val());
  
    var default_price_min_value = parseFloat(default_price_min);
    var formatted_min_price = ""+Shopify.formatMoney(default_price_min_value*100, theme.moneyFormat);
  
  if (isNaN(price_min_value) != false) {    
        alert(translations.titlePleaseEnterValueInNumber);  
    jQuery('#price_from').val(formatted_min_price);
        return false;
  } else if (price_min_value < default_price_min) {  
        alert(translations.titleIncorrectPriceRange);   
    jQuery('#price_from').val(formatted_min_price);
    return false;
  } else if (price_min_value > price_max_value) { 
        alert(translations.titleIncorrectPriceRange);        
    price_slider_render(default_price_min, price_max_value, false, filterLabel);
    return false;
  }

  jQuery('#price_left_hidden').val(price_min_value.toFixed(0));
  jQuery('#price_right_hidden').val(price_max_value.toFixed(0));
  price_slider_render(price_min_value, price_max_value, false, filterLabel);

}

function replace_price_to(ele,priceMax,filterLabel) {
  if ($('#price_to').val() == ''){
    var value = parseFloat($('#price_right_hidden').val());
        var formatted_min_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
    $('#price_to').val(formatted_min_price);        
    return false;
  } else {
    var price_max = $('#price_to').val();        
  }

    var price_max_value = parseInt(getPriceWithoutSymbolAndCommas(price_max));
    var price_min_value = parseInt(jQuery('#price_left_hidden').val());

    var default_price_max_value = parseFloat(default_price_max);
    var formatted_max_price = ""+Shopify.formatMoney(default_price_max_value*100, theme.moneyFormat);
  
  if (isNaN(price_max_value) != false) {
        alert(translations.titlePleaseEnterValueInNumber);        
    jQuery('#price_to').val(formatted_max_price);
        return false;
  } else if (price_max_value > default_price_max) {         
        alert(translations.titleIncorrectPriceRange);
    jQuery('#price_to').val(formatted_max_price);        
    return false;
  } else if (price_min_value > price_max_value) {       
        alert(translations.titleIncorrectPriceRange);
    jQuery('#price_to').val(formatted_max_price);        
    return false;
  } else if (price_min_value == '') {
    jQuery('#price_from').val(price_min_value);
  }

  jQuery('#price_right_hidden').val(price_max_value.toFixed(0));
  jQuery('#price_left_hidden').val(price_min_value.toFixed(0));
  price_slider_render(price_min_value, price_max_value, false, filterLabel);
}
function getPriceWithoutSymbolAndCommas(input_price) {
  if (!input_price) return '';
  var str = input_price.toString().trim();

  // Keep only digits, dots, and commas
  str = str.replace(/[^\d.,]/g, '');
  if (str === '') return '';

  var lastDot = str.lastIndexOf('.');
  var lastComma = str.lastIndexOf(',');
  var decimalIndex = Math.max(lastDot, lastComma); // whichever separator appears LAST is the decimal point

  if (decimalIndex === -1) {
    // No separators at all — plain integer string
    return str;
  }

  var intPart = str.substring(0, decimalIndex).replace(/[.,]/g, '');   // strip any remaining thousands separators
  var decPart = str.substring(decimalIndex + 1).replace(/[.,]/g, '');

  return decPart ? intPart + '.' + decPart : intPart;
}

  // function getPriceWithoutSymbolAndCommas(input_price) {
  //   var price = input_price;
  //   if(input_price.indexOf("$") >= 0){
  //     price = input_price.replace('$', '');
  //     price = price.replace(/[^\d\.]/g, '');
  //   }else if(input_price.indexOf("€") >= 0){
  //     price = input_price.replace('€', '');
  //     price = price.replace(/\./g, '');   
  //   }else if(input_price.indexOf("£") >= 0){
  //     price = input_price.replace('£', '');
  //     price = price.replace(/\./g, '');   
  //   }
  //   return price;
  // }

// function getPriceWithoutSymbolAndCommas(input_price) {
//   if (!input_price) return 0;

//   // Remove everything except digits and decimal point
//   var cleaned = input_price
//     .toString()
//     .replace(/[^0-9.]/g, '');

//   return cleaned;
// }
/*** Diamond Price Filter End ***/

/*** Sort Filter Start ***/ 
$(document).on("click", ".tps-sort-option", function() {
  sortByClose();
  emptyProductResultDiv();
  
  var sort_by = $(this).attr('data-sort');
  var sort_title = $(this).attr('data-title');
  var sort_type = $(this).attr('data-type');
  
  jQuery('#sort_by').val(sort_by);

  jQuery('.tps-sort-by-value').html('<span>'+sort_title+'</span>');
  jQuery('.tps-sort-option').removeClass('active');
  jQuery('.tps-sort-'+sort_by).addClass('active');
  
  jQuery('#page_no').val(1);
  
  ajaxDataCall(); 
  
  updateSessionFilters(session_variable+'-other-data','Sort-By',sort_by);
  updateSessionFilters(session_variable+'-other-data','Sort-Title',sort_title);
});
/*** End ***/

/*** Set Session Selected Sort Filter Start ***/
function setSessionSelectedSortValues(sortBy,sortTitle) {  
  jQuery('.tps-sort-option').removeClass('active');
  jQuery('.tps-sort-'+sortBy).addClass('active');  

  jQuery('.tps-sort-by-value').html(sortTitle);
}
/*** Set Session Selected Sort Filter End ***/

/*** CheckBox Type Filter Selection Common Function Start ***/
function setSettingCheckboxtypeFilter(ele,parentClass,valueid,filter){  
     var filter_value = jQuery(ele).find("input").attr('data-value');
     var filterLable = filter.toLowerCase(); 
     emptyProductResultDiv();

     if(jQuery(ele).hasClass('selected')){
        filter_value = '';
        jQuery(ele).removeClass('selected');
        $('#'+valueid).val('');
     }else{     
        jQuery('.tps-filter-'+filterLable+'-li').removeClass('selected');
        jQuery(ele).addClass('selected');
         $('#'+valueid).val(filter_value);
     }  
       
    jQuery('#page_no').val(1);
    ajaxDataCall();
    updateSessionFilters(session_variable+'-filters',filter, filter_value);
  
    //Applied filter code start 
    var filterTitle = filter+': '+filter_value;
    var filterFunction = "remove"+filter+"Filter('"+filter_value+"')"; 
    var hasClass = jQuery(ele).hasClass('selected');
    setSettingSelectedFilter(filterTitle,filterFunction,hasClass,filterLable);
    //end  
}
/*** End ***/

/*** Remove Shape Filter From Applied Filter Start ***/
function removeShapeFilter(shape){ 
  jQuery('.tps-filter-shape-list input[data-value="'+shape+'"]').click();
}
/*** Remove Shape Filter From Applied Filter End ***/

/*** Remove Metal Filter From Applied Filter Start ***/
function removeMetalFilter(metal){ 
  jQuery('.tps-filter-metal-list input[data-value="'+metal+'"]').click();
}
/*** Remove Metal Filter From Applied Filter End ***/

/*** Remove Style Filter From Applied Filter Start ***/
function removeStyleFilter(style){ 
  jQuery('.tps-filter-style-list input[data-value="'+style+'"]').click();
}
/*** Remove Style Filter From Applied Filter End ***/

/*** Set Selected Filters For Session Filters After Reloading Page start ***/
function setSettingSelectedFilter(filter_value, func, hasSelectedClass, input_value = '') {    
  if (input_value == 'price') {
    $('.tps-selected-filter-container').find('li[data-input="price"]').remove();
  }else if (input_value == 'shape') {     
    $('.tps-selected-filter-container').find('li[data-input="shape"]').remove();
  }else if (input_value == 'style') {
    $('.tps-selected-filter-container').find('li[data-input="style"]').remove();
  }else if (input_value == 'metal') {
    $('.tps-selected-filter-container').find('li[data-input="metal"]').remove();
    }
  
  var value = filter_value.split(':');
   
  if (hasSelectedClass) {
    var html = '';
        var filter_lable = value[1].trim();
        if(input_value != 'price') {
          //filter_lable = filter_lable.replace(/\-/g, ' ');
        }
    html += '<li onclick="' + func + '" data-input="' + input_value + '" data-filter-value="' + filter_value + '"><div class="tps-filter-values">' + filter_lable + '<span class="tps-filter-remove-option"></span></div></li>';
    if ($('#' + value[0] + '-container').length > 0) {
      $('#' + value[0] + '-container').append(html);
    } else {
      var elecontainer = '<ul id="' + value[0] + '-container"><span class="tps-applied-filter-lable">' + value[0] + ':</span></ul>';
      $('.tps-selected-filter-container').append(elecontainer);
      $('#' + value[0] + '-container').append(html);
    }    
  } else {
    $('.tps-selected-filter-container').find('li[data-filter-value="' + filter_value + '"]').remove();
    if ($('input[value="' + input_value + '"]').length > 0) {
      $('input[value="' + input_value + '"]').prop('checked', false);
    }

    if ($('#' + value[0] + '-container li').length == 0) {
      $('#' + value[0] + '-container').remove();
    }
  }
  if ($('.tps-selected-filter-container li').length > 0) {
    $('.tps-selected-filter-wrapper').show();
  } else {
    $('.tps-selected-filter-wrapper').hide();
  }

    //display applied filter count for mobile view start
    var filterlength = $(".tps-selected-filter-container ul").length;
    if(filterlength > 0){
      $(".tps-total-filter-applied").text('('+filterlength+')');
    } 
    //display applied filter count for mobile view end
}
/*** Set selected filters for session filters after reloading page end ***/

/*** Insert Session Selected Values In Input Fields Start ***/
function getSessionSelectedSettingFilterValues(session_data) {  
  $.each(session_data, function(key,value){ 
    var inputKey = key.toLowerCase();
    
    if(key == 'Shape' || key == 'Metal' || key == 'Style'){    
        if(value != ''){
          var inputValues = value.toString();          
          $('#setting_'+inputKey).val(inputValues);
    
          var filterArrayKey = key;
          var filterArrayValues = value;
    
          setTimeout(function(){ 
            setSessionSelectedSettingCheckBoxFilters(filterArrayKey,filterArrayValues);
          }, 50);  
        }
    }else if(key == 'Price'){
      $('#'+inputKey+'_left_hidden').val(value[0]);
      $('#'+inputKey+'_right_hidden').val(value[1]);
    }
     
  });    
}
/*** Insert Session Selected Values In Input Fields End ***/

/*** Set Session Selected Checkbox Type Filters Start ***/
function setSessionSelectedSettingCheckBoxFilters(filterKey,filterValues) {
  $(filterValues).each(function(index, value) {        
      var filterTitle = filterKey.toLowerCase();
      var filterValue = value.toLowerCase();      
      filterValue = filterValue.replace(/\s+/g, '-');
    
      $(".tps-filter-"+filterTitle+"-checkbox-"+filterValue).prop('checked', true);
      $(".tps-filter-"+filterTitle+"-"+filterValue).addClass('selected');
       
      var filterSelectedValues = filterKey+': '+value; 
      setSettingSelectedFilter(filterSelectedValues,"remove"+filterKey+"Filter('"+value+"')",true,filterTitle);
   });  
}
/*** Set Session Selected Checkbox Type Filters End ***/

/*** Get All Setting Products Start ***/ 
function ajaxDataCall(){  
   //getWishlistProducts();
   var session_variable = jQuery("#session_variable").val();
   var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
     
   jQuery(".tps-productlist-result-grid-view-loader").show();
   jQuery("#tps_product_count").html("(<span class='tps-product-count-loader'></span>)");
   //var ringSettingUrl = shopUrl+'/collections/'+collectionHandel+'/products.json?limit=250&page=1'; //get ring setting products using shopify api
   var ringSettingUrl = shopUrl+'/collections/'+collectionHandel+'/products.json?sort_by=manual&limit=250&page=1';   
   //console.log("ringSettingUrl",ringSettingUrl);
    // var ringSettingUrl = settingJsonUrl;
   var prodGridView = '';

   var session_flag = 0;
   if(session_other_data != '' && session_other_data != null){
     if(session_other_data['Back-To-Search-Flag'] != null && session_other_data['Back-To-Search-Flag'] != '' && session_other_data['Back-To-Search-Flag'] != undefined){
        if(session_other_data['Product-Id'][0] != undefined){
          var session_flag = 1;
        }
      }
   }

  var productsPerPage = jQuery("#products_per_page").val();
  if(session_flag != 0){
    var recentPageNo = session_other_data['Recent-Product-Page-No'][0];
    jQuery("#page_no").val(recentPageNo);
    var pageNo = recentPageNo;
    var productShow = recentPageNo * productsPerPage;
    var showFrom = 0;
    var showTo = parseInt(productShow) - 1;
  }else{
     var pageNo = jQuery("#page_no").val();
     var productShow = pageNo * productsPerPage;
     var showFrom = productsPerPage * (pageNo - 1);
     var showTo = parseInt(showFrom) + parseInt(productsPerPage) - 1;
   }       

   abortAjax(xhr);
   
    $("#tps-infinite-loader").show(); // Show loader
   var productDataArray = [];
  
   xhr = $.ajax({
     type: 'GET',
     url: ringSettingUrl,
     dataType: 'json',
     success: function (data){   
   //  console.log('data',data);
       var productsData = productFilters(data.products); //product filter function  
    //    console.log('productsData',productsData);
       var productCount = productsData.length;
       
       jQuery("#tps_product_count").html("("+addCommas(productCount)+")");
       jQuery("#total_products_count").val(productCount);
       jQuery(".tps-total-products").html(addCommas(productCount));

       if(parseInt(productCount) > 0){
         $('.tps-product-grid-view-container').removeClass('tps-no-product');
         var swatchesData = new Array();

         // setTimeout(function(){
           $.each(productsData, function (i, product) {                
             if(i >= showFrom && i <= showTo){
               prodGridView += getProductGridViewLayout(product,collectionHandel,i);  
             }
           });
         
         // }, 500);

         jQuery('.tps-productlist-result-grid-view-items-list').append(prodGridView);  
       }else{
         //no products found
          jQuery('.tps-productlist-result-grid-view-items-list').html('');
          prodGridView += '<span class="tps-no-product-found">'+translations.titleNoProductFound+'</span>';      
          jQuery('.tps-productlist-result-grid-view-items-list').addClass('tps-no-product-found'); 
          jQuery('.tps-productlist-result-grid-view-items-list').append(prodGridView);  
       }       

      //  if(productCount < productsPerPage || productCount == productsPerPage){
      //     var previous_page_no = parseInt(pageNo)-1;
      //     var total_previous_products = previous_page_no*productsPerPage;
      //     var products_viewed = parseInt(total_previous_products)+parseInt(productCount);        
      //     if(productCount == 0){
      //       var products_viewed = productCount;
      //       jQuery('.tps-load-more-button-section').hide();
      //     }else{
      //       var products_viewed = parseInt(total_previous_products)+parseInt(productCount); 
      //       jQuery('.tps-load-more-button-section').show();
      //     }                    
      //     jQuery('.tps-total-products-displays').html(addCommas(products_viewed));
      //     jQuery(".tps-load-more").hide();
      // }else{       
      //     jQuery(".tps-load-more").show();
      //     if(pageNo == 1){    
      //         var products_viewed = productsPerPage;
      //     }else{
      //         var products_viewed = pageNo*parseInt(productsPerPage);
      //         if(products_viewed > productCount){
      //           products_viewed = productCount;
      //           if(products_viewed == productCount){
      //             jQuery(".tps-load-more").hide();
      //           }
      //         }              
      //     }    
      //     jQuery('.tps-total-products-displays').html(addCommas(products_viewed));          
      //     jQuery('.tps-load-more-button-section').show();
      // }  
      //console.log("productCount",productCount);
      //console.log("productsPerPage",productsPerPage);
      if(productCount < productsPerPage || productCount == productsPerPage){
        var previous_page_no = parseInt(pageNo)-1;
        var total_previous_products = previous_page_no*productsPerPage;
        var products_viewed = parseInt(total_previous_products)+parseInt(productCount); 
        if(productCount == 0){
            var products_viewed = productCount;
            jQuery("#tps-infinite-loader").hide(); 
            
        }else{
            var products_viewed = parseInt(total_previous_products)+parseInt(productCount); 
            jQuery("#tps-infinite-loader").show();             
        }                    
        //  jQuery('.tps-total-products-displays').html(addCommas(products_viewed));
      }else{
          jQuery("#tps-infinite-loader").show();
          if(pageNo == 1){    
              var products_viewed = productsPerPage;
          }else{
              var products_viewed = pageNo*parseInt(productsPerPage);
              if(products_viewed > productCount){
                products_viewed = productCount;
                if(products_viewed == productCount){
                  jQuery("#tps-infinite-loader").hide();
                }
              }              
          }    
         // jQuery('.tps-total-products-displays').html(addCommas(products_viewed));          
          jQuery('.tps-load-more-button-section').show();
      }
       
      // Pagination logic
      // const previous_page_no = parseInt(pageNo) - 1;
      // const total_previous_products = previous_page_no * productsPerPage;
      // let products_viewed = parseInt(total_previous_products) + parseInt(productCount);
      //   console.log("products_viewed",products_viewed);
      // $('.tps-total-products-displays').html(addCommas(products_viewed));


       //product info focus return from product detail page          
        if(session_flag != 0){
            var recentProduct = session_other_data['Product-Id'][0];            
            focusRecentProduct(recentProduct);            
        }             
        //end 

       jQuery(".tps-productlist-result-grid-view-loader").hide();
       $("#tps-infinite-loader").hide(); // Hide infinite loader
      //  var page_id = parseInt(pageNo)+1;  
      //  jQuery('#page_no').val(page_id);          
      
      // // Stop infinite scroll and hide loader if all products loaded
      // if(products_viewed >= productCount){
      //     tps_noMoreProducts = true;
      //     $("#tps-infinite-loader").hide(); // hide loader permanently
      // } else {
      //     tps_noMoreProducts = false;
      //     $("#tps-infinite-loader").show(); // show loader for next batch
      // }
        // Numbered pagination: keep page_no as the page currently displayed
        // (previously this incremented page_no for infinite scroll/load-more)
        jQuery('#page_no').val(pageNo);

        createPaginationLayout(pageNo, productCount, productsPerPage);

              tps_isLoading = false;
              //createPaginationLayout(page_id,productCount,productsPerPage);
      },
      error: function () {
      $("#tps-infinite-loader").hide();
      tps_isLoading = false;
    }

   });
}
/*** Get All Setting Products End ***/ 


/*** Pagination Layout Start ***/

// ================================================
// Infinite Scroll Setup
// ================================================
let tps_isLoading = false;        // Prevents multiple triggers
let tps_noMoreProducts = false;   // Stops when no more products
// Dynamic scroll trigger offset based on window height
const tps_scrollTriggerOffset = Math.round($(window).height() * 0.85); // 50% of viewport height
let lastScrollTime = 0;           // Throttle time in ms
const scrollThrottle = 300;       // minimum interval between scroll triggers


// $(window).on('scroll', function() {
//     const now = Date.now();
//     if (now - lastScrollTime < scrollThrottle) return; // throttle
//     lastScrollTime = now;

//     if (tps_isLoading || tps_noMoreProducts) return;

//     const scrollTop = $(window).scrollTop();
//     const windowHeight = $(window).height();

//     // Use product list bottom as trigger
//     const productList = $('.tps-productlist-result-grid-view-items-list');
//     if (!productList.length) return;

//     const productListBottom = productList.offset().top + productList.outerHeight();

//     // Trigger 100px before the bottom of product list
//     if (scrollTop + windowHeight >= productListBottom - 100) {
//         tps_isLoading = true;   // block further triggers until this load finishes
//         ajaxDataCall();
//     }
// });

// $(window).on('scroll', function() {
//   const now = Date.now();
//   if (now - lastScrollTime < scrollThrottle) return; // throttle
//   lastScrollTime = now;

//   if (tps_isLoading || tps_noMoreProducts) return;

//   const scrollTop = $(window).scrollTop();
//   const windowHeight = $(window).height();
//   const docHeight = $(document).height();
//   const productList = $('.tps-productlist-result-grid-view-items-list');

//   if (!productList.length) return;

//   const productListTop = productList.offset().top;
//   const productListBottom = productListTop + productList.outerHeight();

//   // --- Visibility Zones ---
//   const viewportBottom = scrollTop + windowHeight;

//   // 🧩 1. Completely below list (jumped to footer)
//   const isCompletelyBelowList = scrollTop > productListBottom + 300;

//   // 🧩 2. In-between zone (part footer + part listing visible)
//   const isBetweenSections =
//     viewportBottom > productListTop + 100 && scrollTop < productListBottom - 100;

//   // 🧩 3. Near bottom of listing (typical infinite scroll trigger)
//   const nearBottomOfList = viewportBottom >= productListBottom - 200;

//   // 🚫 Skip only if user is *way* below product list
//   if (isCompletelyBelowList) return;

//   // ✅ Trigger in any of these cases:
//   // - near bottom of list
//   // - in between list & footer (partial view)
//   // - near page bottom (in case content height is short)
//   if (nearBottomOfList || isBetweenSections || viewportBottom >= docHeight - 150) {
//     tps_isLoading = true;
//     ajaxDataCall();
//   }
// });

/*** Pagination Layout Start ***/
// function createPaginationLayout(currentPage, totalGemstones, perPage) {
//     currentPage = parseInt(currentPage, 10);
//     var visiblePages = 4;
//     var totalPages = Math.ceil(totalGemstones / perPage);

//     if (totalGemstones === 0 || totalPages === 0) {
//         $('#tps_pagination').html('');
//         return;
//     }

//     var startPage = Math.max(1, currentPage - Math.floor(visiblePages / 2));
//     var endPage = startPage + visiblePages - 1;

//     if (endPage > totalPages) {
//         endPage = totalPages;
//         startPage = Math.max(1, endPage - visiblePages + 1);
//     }

//     let paginationHTML = '<ul class="tps-pagination">';

//     // Only show FIRST if not on page 1
//     if (currentPage > 1) {
//         paginationHTML += `
//             <li>
//                 <button onclick="changePage(1)">FIRST</button>
//             </li>
//         `;
//     }

//     // PREV button
//     paginationHTML += `
//         <li class="${currentPage === 1 ? 'disabled' : ''}">
//             <button ${currentPage === 1 ? 'disabled' : `onclick="changePage(${currentPage - 1})"`}>PREV</button>
//         </li>
//     `;

//     // Numbered pages
//     for (let i = startPage; i <= endPage; i++) {
//         paginationHTML += `
//             <li class="${i === currentPage ? 'active' : ''}">
//                 <button ${i === currentPage ? 'disabled' : `onclick="changePage(${i})"`}>${i}</button>
//             </li>
//         `;
//     }

//     // NEXT button
//     paginationHTML += `
//         <li class="${currentPage === totalPages ? 'disabled' : ''}">
//             <button ${currentPage === totalPages ? 'disabled' : `onclick="changePage(${currentPage + 1})"`}>NEXT</button>
//         </li>
//     `;

//     // Only show LAST if not on the last page
//     if (currentPage < totalPages) {
//         paginationHTML += `
//             <li>
//                 <button onclick="changePage(${totalPages})">LAST</button>
//             </li>
//         `;
//     }

//     paginationHTML += '</ul>';

//     $('#tps_pagination').html(paginationHTML);
// }
/*** Pagination Layout End ***/
// Called when user clicks pagination buttons
// function changePage(pageNo) {
//   jQuery('#page_no').val(pageNo);
  
//   var activeTab = jQuery('#diamond_active_tab').val();
//   var viewType = getViewType();
//   $('.tps-diamondlist-result-'+viewType+'-view-items-list').html('');
//   var target = ".tps-"+activeTab+"-diamond-data .tps-diamond-"+viewType+"-listing-loader";

//   $('html, body').animate({
//         scrollTop: $(target).offset().top - 300
//   }, 'slow'); 

//   ajaxDataCall();
// }

/*** Pagination Layout Start ***/
function createPaginationLayout(currentPage, totalProducts, perPage) {
    currentPage = parseInt(currentPage, 10);
    perPage = parseInt(perPage, 10);
    var visiblePages = 3; // how many consecutive numbers to show (e.g. 1 2 3)
    var totalPages = Math.ceil(totalProducts / perPage);

    if (totalProducts === 0 || totalPages <= 0) {
        $('#tps_pagination').html('');
        return;
    }

    // Keep the window of numbers anchored around the current page
    var startPage = Math.max(1, currentPage - 1);
    var endPage = startPage + visiblePages - 1;

    if (endPage > totalPages) {
        endPage = totalPages;
        startPage = Math.max(1, endPage - visiblePages + 1);
    }

    var paginationHTML = '<ul class="tps-pagination">';

    // FIRST
    paginationHTML += '<li class="tps-page-nav' + (currentPage === 1 ? ' disabled' : '') + '">' +
        (currentPage === 1
            ? '<span>' + 'FIRST' + '</span>'
            : '<a onclick="changePage(1)">' + 'FIRST' + '</a>') +
        '</li>';

    // PREV
    paginationHTML += '<li class="tps-page-nav' + (currentPage === 1 ? ' disabled' : '') + '">' +
        (currentPage === 1
            ? '<span>' + 'PREV' + '</span>'
            : '<a onclick="changePage(' + (currentPage - 1) + ')">' + 'PREV' + '</a>') +
        '</li>';

    // Numbered pages
    for (var i = startPage; i <= endPage; i++) {
        paginationHTML += '<li class="tps-page-number' + (i === currentPage ? ' active' : '') + '">' +
            (i === currentPage
                ? '<span>' + i + '</span>'
                : '<a onclick="changePage(' + i + ')">' + i + '</a>') +
            '</li>';
    }

    // Ellipsis + last page, only if the last page isn't already shown in the window above
    if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
            paginationHTML += '<li class="tps-page-dots"><span>&hellip;</span></li>';
        }
        paginationHTML += '<li class="tps-page-number"><a onclick="changePage(' + totalPages + ')">' + totalPages + '</a></li>';
    }

    // NEXT
    paginationHTML += '<li class="tps-page-nav' + (currentPage === totalPages ? ' disabled' : '') + '">' +
        (currentPage === totalPages
            ? '<span>' + 'NEXT' + '</span>'
            : '<a onclick="changePage(' + (currentPage + 1) + ')">' + 'NEXT' + '</a>') +
        '</li>';

    // LAST
    paginationHTML += '<li class="tps-page-nav' + (currentPage === totalPages ? ' disabled' : '') + '">' +
        (currentPage === totalPages
            ? '<span>' + 'LAST' + '</span>'
            : '<a onclick="changePage(' + totalPages + ')">' + 'LAST' + '</a>') +
        '</li>';

    paginationHTML += '</ul>';

    $('#tps_pagination').html(paginationHTML);
}
/*** Pagination Layout End ***/

// Called when user clicks a pagination button
function changePage(pageNo) {
  var totalProductsCount = parseInt(jQuery('#total_products_count').val()) || 0;
  var productsPerPage = parseInt(jQuery('#products_per_page').val());
  var totalPages = Math.ceil(totalProductsCount / productsPerPage);

  pageNo = parseInt(pageNo, 10);
  if (isNaN(pageNo) || pageNo < 1) pageNo = 1;
  if (pageNo > totalPages) pageNo = totalPages;

  jQuery('#page_no').val(pageNo);

  // Clear the current grid — each page replaces the previous one instead of appending
  jQuery('.tps-productlist-result-grid-view-items-list').html('');

  // Scroll back to the top of the listing
  var target = '#tps-product-list-grid-container';
  if ($(target).length) {
    $('html, body').animate({
      scrollTop: $(target).offset().top - 150
    }, 'slow');
  }

  ajaxDataCall();
}


/*** Focus Recently View Product Start ***/
function focusRecentProduct(product_id) {
  var target = '.product-grid-item-'+product_id;

  if($(target).length) {
    $(target).addClass('tps-recent-viewed-product');
    $('html, body').animate({
          scrollTop: $(target).offset().top - 300
    }, 'slow'); 
  }  
  updateSessionFilters(session_variable+'-other-data','Product-Id', '');
  updateSessionFilters(session_variable+'-other-data','Recent-Product-Page-No', '');
  updateSessionFilters(session_variable+'-other-data','Back-To-Search-Flag', '');
  setTimeout(function(){ $(target).removeClass('tps-recent-viewed-product'); }, 4000);
}
/*** End ***/

/*** Get Product Grid View layout Start ***/ 
function getProductGridViewLayout(product,collectionHandel,diamondIndex){  
  var wishlistProducts = jQuery("#wishlist_products").val();
  wishlistProducts = wishlistProducts.split(",");
  //console.log("product",product);
  var banner_display_count = jQuery('#tps_banner_row_count').val();
  var diamond_index = (diamondIndex % 40)+1;   
 
   //Get Hover Image
  var images = product.images;
   console.log("images",images);
  const altAndSrc = images.map(image => ({
    alt: image.alt,
    src: image.src
  }));
  
  var pageNo = jQuery("#page_no").val();
  var metalFilter = jQuery("#setting_metal").val();
  var filteredMetal = metalFilter.replace(/^18K\s/, '');
  filteredMetal = metalFilter.replace(/^18ct\s/, '');
  filteredMetal = metalFilter.replace(/^14K\s/, '');
  filteredMetal = metalFilter.replace(/^18ct\s/, '');
  filteredMetal = metalFilter.replace(/^9K\s/, '');
  filteredMetal = metalFilter.replace(/^9ct\s/, '');
 

  // Filter images, ensuring alt exists and starts with the filteredMetal
  const filteredImages = altAndSrc.filter(item => 
    item.alt && typeof item.alt === 'string' && item.alt.startsWith(filteredMetal)
  );
  
  // Get the appropriate src based on the condition
  const singleSrc = filteredImages.length > 0 
    ? (filteredImages[1] ? filteredImages[1].src : filteredImages[0].src) // Use the 1st position image if it exists, otherwise the 0th position
    : altAndSrc[0].src; // Fallback to the 0th position image from the original array
  
  
  
  var produtSwaches = getProductSwatches(product,collectionHandel);  
  var productVariant = getProductVariant(product,collectionHandel); 
  //console.log('productVariant',productVariant);
  var productPrice = Shopify.formatMoney(productVariant[0].price * 100, theme.moneyFormat);
      productPrice = productPrice.replace(/([.,]00)$/, '');
  var productCompareAtPrice = Shopify.formatMoney(productVariant[0].compare_at_price * 100, theme.moneyFormat);
  // var productImage = productVariant[0].image;
  // var productHoverImage = productVariant[0].secondImage; 
  var productDefaultVariant = productVariant[0].metal;
 
  console.log("productVariant",productDefaultVariant);
 

  var productImage = productVariant[0].image;

// Get hover image only from same metal images
var productHoverImage = productImage;

if(filteredImages.length > 1){
  productHoverImage = filteredImages[1].src;
}
  

  var productGrid = '';
  productGrid += '<li class="tps-productlist-result-grid-view-item product-grid-row product-grid-item-'+product.id+'" data-id="'+product.id+'" data-page="'+pageNo+'">'; 
  productGrid += '<div class="tps-productlist-item-media-div-section tps-productlist-item-media-div-'+product.id+'">';

  /*** product wishlist functionality start ***/
  if(jQuery.inArray(product.id.toString(),wishlistProducts)==(-1)){
    //display add to wishlist button    
    var addToWishlist = 'Xb-add';
    var removeFromWishlist = '';    
  }else{
    //display remove from wishlist button 
    var addToWishlist = '';
    var removeFromWishlist = 'Xb-add';     
  } 
  
  productGrid += '<div class="xb-wishlist__btn-custom">';
  productGrid += '<div class="xb-wishlist__add" xb-product-id="'+product.id+'" xb-product-title="'+product.title+'" xb-product-variant="'+productVariant[0].id+'" xb-product-handle="'+product.handle+'" '+addToWishlist+'>';
  productGrid += '<button>';
  productGrid += '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#DECD97" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">';
  productGrid += '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>';
  productGrid += '</svg>';
  productGrid += '</button>';
  productGrid += '</div>';

  productGrid += '<div class="xb-wishlist__loading" xb-product-id="'+product.id+'">Loading...</div>';

  productGrid += '<div class="xb-wishlist__remove" xb-product-id="'+product.id+'" xb-product-title="'+product.title+'" xb-product-variant="'+productVariant[0].id+'" xb-product-handle="'+product.handle+'" '+removeFromWishlist+'>';
  productGrid += '<button>';
  productGrid += '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#DECD97" stroke="#DECD97" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">';
  productGrid += '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>';
  productGrid += '</svg>';
  productGrid += '</button>';
  productGrid += '</div>';  
  productGrid += '</div>';
  /*** product wishlist functionality end ***/  

  /*** productquick add functionality start ***/  
  productGrid += '<div class="tps-quick-add">';
  productGrid += '<button class="tps-quick-add-btn" data-product-handle="'+product.handle+'" data-product-id="'+product.id+'">';
   productGrid += '+';
  productGrid += '</button>';
  productGrid += '</div>';
  /*** productquick add functionality end ***/   
  
  productGrid += '<a href="'+productVariant[0].url+'" data-id="'+product.id+'" data-page="1">';
  productGrid += '<div class="tps-productlist-item-media-div">';
  productGrid += '<img class="tps-productlist-item-img tps-product-first-image" data-placeholder-img="" alt="'+product.title+' '+productDefaultVariant+'" title="'+product.title+' '+productDefaultVariant+'" src="'+productImage+'" loading="lazy" width="300" height="300">';
  productGrid += '<img class="tps-productlist-item-img tps-product-second-image" data-placeholder-img="" alt="'+product.title+' '+productDefaultVariant+'" title="'+product.title+' '+productDefaultVariant+'" src="'+productHoverImage+'" loading="lazy" width="300" height="300">';
  productGrid += '</div>';
  productGrid += '</a>';
  productGrid += '</div>';
  
  productGrid += '<div class="tps-productlist-item-wrapper">';
   productGrid += '<div class="tps-productlist-item-wrapper-block swatch-updated-variant-id-'+product.id+'">';
  productGrid += '<a href="'+productVariant[0].url+'" data-id="'+product.id+'" data-page="1">';
  productGrid += '<div class="tps-productlist-item-view-title">'+product.title+'</div>';   
  productGrid += '</a>';
  productGrid += '</div>';
  if(produtSwaches != '' && produtSwaches != null){
    productGrid += '<div class="tps-productlist-item-swatches">';
     let activeMetalName = '';

    $.each(produtSwaches, function (i, swatch) {  
      var metalSwatch = swatch.metal;
      metalSwatch = metalSwatch.replace(/^18K\s/, '');
      metalSwatch = metalSwatch.replace(/^14K\s/, '');
      metalSwatch = metalSwatch.replace(/^9K\s/, '');
      metalSwatch = metalSwatch.replace(/^18ct\s/, '');
      metalSwatch = metalSwatch.replace(/^14ct\s/, '');
      metalSwatch = metalSwatch.replace(/^9ct\s/, '');
      var matchingImages = images.filter(image => image.alt === metalSwatch);
      const imageSrcs = matchingImages.map(image => image.src);
      var hoverImageUrl = swatch.secondImage;
     
      productGrid += '<div class="tps-productlist-item-swatch tps-productlist-item-swatch-'+swatch.id+' '+swatch.active+'" title="'+swatch.metal+'" parent-id="'+product.id+'" data-id="'+swatch.id+'">';
      productGrid += '<div data-id="'+swatch.id+'" onclick="changeProductData(`'+product.title+'`,`'+product.id+'`,`'+swatch.id+'`,`'+swatch.metal+'`,`'+swatch.price+'`,`'+swatch.compare_at_price+'`,`'+swatch.image+'`,`'+swatch.url+'`,`'+hoverImageUrl+'`)">';
      productGrid += '<span class="tps-productlist-item-metal-icon metal-'+swatch.class+'">'+swatch.metal+'</span>';
      productGrid += '</div>';
      productGrid += '</div>';

      // ✅ Capture active metal
      if (swatch.active === 'active') {
        activeMetalName = swatch.metal;
      }
    });

     productGrid += '<div class="metal-active-title metal-title-'+product.id+'">'+activeMetalName+'</div>';
    productGrid += '</div>';
  }
  
  productGrid += '<div class="tps-productlist-item-view-info tps-productlist-item-view-info-'+product.id+'">';
  productGrid += '<a href="'+productVariant[0].url+'" data-id="'+product.id+'" data-page="1">';
  productGrid += '<div class="tps-productlist-item-view-price">'+productPrice+'</div>';   
  
  productGrid += '</a>';
  productGrid += '</div>';
  productGrid += '</div>';
  productGrid += '</li>';

  //banner start  
  if(jQuery(window).width() > 900 && jQuery(window).width() < 1198){    
    banner_display_count = parseInt(banner_display_count)+1; //for tab view display banner after 21 diamonds
  }
  
   
  if(diamond_index == banner_display_count){
      var bannerHtml = $('#tps_banner_blog_'+pageNo).html();
      if(bannerHtml != '' && bannerHtml != undefined){
        productGrid += '<li class="tps-diamondlist-banner-section">';
        productGrid += '<div class="tps-diamond-listing-page-banner">'+bannerHtml+'</div>';
        productGrid += '</li>';
      }
  }  
  //banner end

  return productGrid;
}
/*** Get Product Grid View layout End ***/

/*** On Swatches Click Change Variant Data Start ***/
function changeProductData(productTitle,productId,variantId,variantTitle,variantPrice,variantCompareAtPrice,variantImage,variantUrl,hoverImg){ 
  jQuery('.product-grid-item-'+productId+' .tps-productlist-item-swatch').removeClass('active');
  jQuery('.tps-productlist-item-swatch-'+variantId).addClass('active');
  jQuery('.tps-productlist-item-media-div-'+productId).addClass('tps-gallery-loading');   
  var productPrice = Shopify.formatMoney(variantPrice * 100, theme.moneyFormat);
  var productCompareAtPrice = Shopify.formatMoney(variantCompareAtPrice * 100, theme.moneyFormat);

  var productMedia = '';
  productMedia += '<a href="'+variantUrl+'" data-id="'+productId+'" data-page="1">';
  productMedia += '<div class="tps-productlist-item-media-div">';
  productMedia += '<img class="tps-productlist-item-img tps-product-first-image" data-placeholder-img="" alt="'+productTitle+'" title="'+productTitle+'" src="'+variantImage+'" loading="lazy" width="300" height="300">';
  if (hoverImg !== '' && hoverImg !== null && hoverImg !== undefined){
     productMedia += '<img class="tps-productlist-item-img tps-product-second-image" data-placeholder-img="" alt="'+productTitle+' '+variantTitle+'" title="'+productTitle+' '+variantTitle+'" src="'+variantImage+'" loading="lazy" width="300" height="300">';
  }else{
     productMedia += '<img class="tps-productlist-item-img tps-product-second-image" data-placeholder-img="" alt="'+productTitle+' '+variantTitle+'" title="'+productTitle+' '+variantTitle+'" src="'+variantImage+'" loading="lazy" width="300" height="300">';
  } 
  productMedia += '</div>';
  productMedia += '</a>';  
  jQuery('.tps-productlist-item-media-div-'+productId).html(productMedia);  

  var productinfo = '';
  productinfo += '<a href="'+variantUrl+'" data-id="'+productId+'" data-page="1">';
  //productinfo += '<div class="tps-productlist-item-view-title">'+productTitle+'</div>';  
  productinfo += '<div class="tps-productlist-item-view-price">'+productPrice+'</div>'; 
  //productinfo += '<div class="tps-productlist-item-view-price">'+productPrice+' <span class="tps-price-info">'+translations.titleSettingOnly+'</span></div>'; 
  //productinfo += '<div class="tps-productlist-item-view-price">';  
  // if(productCompareAtPrice != '' || productCompareAtPrice != null){    
  //   productinfo += '<span class="tps-compare-price-info">'+productCompareAtPrice+'</span>';
  //   productinfo += '<span class="tps-price-separator"> / </span>';
  // }
  //productinfo += '<span class="tps-sales-price-info">'+productPrice+'</span>';
  //productinfo += '<span class="tps-price-info"> '+translations.titleSettingOnly+'</span>';
  //productinfo += '</div>'; 
  productinfo += '</a>';

  var producttitleinfo = '';
  producttitleinfo += '<a href="'+variantUrl+'" data-id="'+productId+'" data-page="1">';
  producttitleinfo += '<div class="tps-productlist-item-view-title">'+productTitle+'</div>';   
  producttitleinfo += '</a>';

  jQuery('.swatch-updated-variant-id-'+productId).html(producttitleinfo);  
    jQuery('.metal-title-'+productId).html(variantTitle);  
  jQuery('.tps-productlist-item-view-info-'+productId).html(productinfo);  
  jQuery('.tps-productlist-item-media-div-'+productId).removeClass('tps-gallery-loading');   
}
/*** On Swatches Click Change Variant Data End ***/

/*** Get variant Data After Filter Apply Start ***/
function getProductVariant(product,collectionHandel){
  var variantData = new Array();
  var shapeFilter = jQuery("#setting_shape").val();  
  var metalFilter = jQuery("#setting_metal").val(); 
  var productVariants = product.variants;
  var productHandle = product.handle;   
  var productMedia = product.images;
  
  // var productOptions = product.options;
  var i = 0;

  if(productVariants != ''){
     $(productVariants).each(function(index, variant){
       var variantShape = variant.option2;
       var variantMetal = variant.option1;
       
       if(shapeFilter == '' && metalFilter == ''){
         if(i == 0){
           variantData = getProductSelectedOption(variant,productHandle,productMedia,collectionHandel);
           
           i++;
         }
       }else if(shapeFilter != '' && metalFilter != ''){
         if(shapeFilter == variantShape && metalFilter == variantMetal){
           variantData = getProductSelectedOption(variant,productHandle,productMedia,collectionHandel);
            
         }
       }else if(shapeFilter == '' && metalFilter != ''){
         if(metalFilter == variantMetal){  
            if(i == 0){
              variantData = getProductSelectedOption(variant,productHandle,productMedia,collectionHandel); 
              
              i++;
            }              
         }
       }else if(shapeFilter != '' && metalFilter == ''){
         if(shapeFilter == variantShape){       
           if(i == 0){
             variantData = getProductSelectedOption(variant,productHandle,productMedia,collectionHandel);
              
             i++;
           }
         }
       }
     });
  }
  return variantData;   
}

function getProductSelectedOption(variant,productHandle,productMedia,collectionHandel){
   var variantInfo = new Array();
   var variantShape = variant.option2;
   var variantMetal = variant.option1;
   var varientImage = placeholderImageUrl.ring_placeholder;
   var varientSecondImage = placeholderImageUrl.ring_placeholder;
   var varientFeaturedImage  = variant.featured_image;
   var varientalt  = varientFeaturedImage.alt;
  
        
   if(varientFeaturedImage != null){
     varientImage = getImageByID(productMedia,variant.featured_image.id);
     varientSecondImage = getSecondImageByID(productMedia,variant.featured_image.id);
   } 
 
   var productUrl = '/collections/'+collectionHandel+'/products/'+productHandle+'?variant='+variant.id+'&sku='+variant.sku;
  
   variantInfo.push({
      id: variant.id,
      sku: variant.sku,
      shape: variantShape,
      metal: variantMetal,
      url: productUrl,
      alt: varientalt,
      image: varientImage,
      secondImage: varientSecondImage,
      price: variant.price,
      compare_at_price: variant.compare_at_price,
   });
  
  return variantInfo;
}
/*** Get variant Data After Filter Apply End ***/

/*** Get Product Swatches Data Start ***/
function getProductSwatches(product,collectionHandel){
   var swatchesData = new Array();
   var productVariants = product.variants;
   var productImages = product.images;
   var shapeFilter = jQuery("#setting_shape").val(); 
   var metalFilter = jQuery("#setting_metal").val();
   var diaQualityFilter = jQuery("#setting_diamond_quality").val(); 
   var productOptions = product.options;
 //console.log("productOptions",productOptions);
   var productMetalArray = productOptions[0].values;
   var productShapeArray = productOptions[1].values;
   var productDiaQualityArray = productOptions[2].values;
   var productDefaultShape = productShapeArray[0];
   var productDefaultMetal = productMetalArray[0];
   var productDefaultDiaQuality = productDiaQualityArray[0];
   var i = 0;
 // console.log("productVariants",productVariants);
   if(productVariants != ''){
     $(productVariants).each(function(index, option){  
         var variantMetal = option.option1;  
         var variantShape = option.option2;
         var variantdiaQuality = option.option3;
         var metalClass = variantMetal.toLowerCase();
         metalClass = metalClass.replace(/\s+/g,"-");         

         var active = '';
         if(metalFilter == variantMetal){
           var active = 'active'; 
         }else if(metalFilter == '' && productDefaultMetal == variantMetal && productDefaultShape == variantShape && productDefaultDiaQuality == variantdiaQuality ){
           var active = 'active'; 
         }
       
         if(shapeFilter != '' && variantShape == shapeFilter && diaQualityFilter != '' && variantdiaQuality == diaQualityFilter){                       
             var productUrl = '/collections/'+collectionHandel+'/products/'+product.handle+'?variant='+option.id+'&sku='+option.sku;
             var imageUrl = placeholderImageUrl.ring_placeholder;
             var varientSecondImage = placeholderImageUrl.ring_placeholder;            
             if(option.featured_image != null && option.featured_image != undefined){                
               imageUrl = getImageByID(productImages,option.featured_image.id);
               varientSecondImage = getSecondImageByID(productImages,option.featured_image.id);
             }
                      
             swatchesData.push({
                id: option.id,
                sku: option.sku,
                metal: variantMetal,
                shape: variantShape,
                diamond_quality: variantdiaQuality,
                class: metalClass,
                url: productUrl,
                active: active,
                image: imageUrl,
                price: option.price,
                compare_at_price : option.compare_at_price,
                secondImage: varientSecondImage,
             });
         }else if(shapeFilter == ''){                 
             var productUrl = '/collections/'+collectionHandel+'/products/'+product.handle+'?variant='+option.id+'&sku='+option.sku;  
             var imageUrl = placeholderImageUrl.ring_placeholder;
             var varientSecondImage = placeholderImageUrl.ring_placeholder; 
             
             if(option.featured_image != null && option.featured_image != undefined){           
               imageUrl = getImageByID(productImages,option.featured_image.id);
               varientSecondImage = getSecondImageByID(productImages,option.featured_image.id);
             }             
           
             // if(index <= 3){
               if(productDefaultShape == variantShape && productDefaultDiaQuality == variantdiaQuality){
                 swatchesData.push({
                      id: option.id,
                      sku: option.sku,
                      metal: variantMetal,
                      shape: variantShape,
                      diamond_quality: variantdiaQuality,
                      class: metalClass,
                      url: productUrl,
                      active: active,
                      image: imageUrl,
                      price: option.price,
                      compare_at_price : option.compare_at_price,
                      secondImage: varientSecondImage,
                   });
               }
                 
           
             // }
         }
           
     });
   }  
   return swatchesData;
}
/*** Get Product Swatches Data End ***/

/*** Get Image URL By Its ID Start ***/
function getImageByID(productImages,imageId) {
  // var imageUrl = placeholderImageUrl.ring_placeholder;
  // var varientSecondImage = placeholderImageUrl.ring_placeholder;
  // console.log(imageId);
  var imageUrlArray = new Array();
  $(productImages).each(function(index, image){   
    if(image.id == imageId){
      var imageUrl = image.src;
      imageUrlArray.push(imageUrl);
    }
  });
  // console.log("image url "+imageUrlArray[0]);
  return imageUrlArray[0];
}
/*** Get Image URL By Its ID End ***/

/*** Get Image URL By Its ID Start ***/
function getSecondImageByID(productImages,imageId) {
  var imageUrlArray = new Array();
  var imageIndex = new Array();
  $(productImages).each(function(index, image){   
    if(image.id == imageId){      
      var image_index = index+1;
      imageIndex.push(image_index);
    }

    if(imageIndex[0] == index){
      var imageUrl = image.src;
      imageUrlArray.push(imageUrl);
    }
  });

  return imageUrlArray[0];
}
/*** Get Image URL By Its ID End ***/
  
/*** Abort XHR Start ***/
function abortAjax(xhr) {
  if(xhr && xhr.readystate != 4){
    xhr.abort();
  }
}
/*** End ***/ 

/*** Onclick Product Store Product ID & PAge No in Session Start ***/
jQuery(document).on("click", ".tps-productlist-result-grid-view-item", function(e) {
  var container = $(".tps-productlist-item-swatches");
  
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0){     
    var data_page_no = $(this).attr("data-page");
    var data_product_id = $(this).attr("data-id");
    
    updateSessionFilters(session_variable+'-other-data','Recent-Product-Page-No', data_page_no);
    updateSessionFilters(session_variable+'-other-data','Product-Id', data_product_id);
    updateSessionFilters(session_variable+'-other-data','Back-To-Search-Flag', 'true');
  }
});
/*** Onclick Product Store Product ID & PAge No in Session End ***/
/*** Mouse Hover update metal title Start***/
jQuery(document).on('mouseenter mouseleave', '.tps-productlist-item-swatch', function (e) {

  var $this = jQuery(this);
  var $wrapper = $this.closest('.tps-productlist-item-swatches');
  var $titleBox = $wrapper.find('.metal-active-title');

  var textToShow;

  if (e.type === 'mouseenter') {
    // On Hover → show hovered swatch title
    textToShow = $this.attr('title');
  } else {
    // On Leave → revert to active swatch
    textToShow = $wrapper
      .find('.tps-productlist-item-swatch.active')
      .attr('title');
  }

  if (textToShow) {
    $titleBox.text(textToShow);
  }

});
/*** Mouse Hover update metal title End***/

/*** Empty Diamond Result Div On Filter Click Start ***/
function emptyProductResultDiv(){   
  jQuery('.tps-productlist-result-grid-view-items-list').removeClass('tps-no-product-found');
  jQuery('.tps-productlist-result-grid-view-items-list').html('');
  var resetFlag = checkResetFlag();
  if(resetFlag != 'true'){
    ajaxDataCall();
  } 
}
/*** End ***/

/*** Reset Filters Start ***/
function resetFilters(){
  var session_variable = jQuery("#session_variable").val();
  localStorage.removeItem(session_variable+'-filters');   
  localStorage.setItem('resetFlag', 'true');
  jQuery(".tps-reset-filter-confirm-popup-div").hide();
  
  if(typeof(Storage) !== "undefined"){
    $('.tps-selected-filter-wrapper').hide();
    $('.tps-selected-filter-container ul').remove();
    
    $('.tps-filter-shape-li').removeClass('selected');
    $(".tps-filter-shape-checkbox").prop('checked', false);
    $('#setting_shape').val('');

    $('.tps-filter-metal-li').removeClass('selected');
    $(".tps-filter-metal-checkbox").prop('checked', false);
    $('#setting_metal').val('');

    $('.tps-filter-style-li').removeClass('selected');
    $(".tps-filter-style-checkbox").prop('checked', false);
    $('#setting_style').val('');

    price_slider_render(default_price_min, default_price_max, true, translations.titlePrice);     

    $('.tps-sort-option').removeClass('active');
    $('.tps-sort-price-ascending').addClass('active');
    jQuery('.tps-sort-by-value').html('<span>'+translations.titlePriceSortLowToHigh+'</span>');
    jQuery('#sort_by').val('price-ascending');     

    updateSessionFilters(session_variable+'-other-data','Sort-By', 'price-ascending');
    updateSessionFilters(session_variable+'-other-data','Sort-Title', translations.titlePriceSortLowToHigh);
    $(".tps-total-filter-applied").text('');
    
    jQuery('#page_no').val(1);
    ajaxDataCall();

    setTimeout(function(){
      localStorage.setItem('resetFlag','false');
    }, 1000);
  }
}
/*** End ***/

/*** Check Reset Flag Start ***/
function checkResetFlag() {
  var resetFlag = localStorage.getItem('resetFlag');
  return resetFlag;
}
/*** Check Reset Flag End ***/

/*** Reset Filter Popoup Close Outer Click Start ***/
jQuery(document).on('click','#MainContent',function(e){
  var container = $(".tps-tab2");
    
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0){     
    jQuery(".tps-reset-filter-confirm-popup-div").hide();
  }
});
/*** Reset Filter Popoup Close Outer Click End ***/
  /**** Tooltip Information Open/Close Start ****/ 
function infoPopup(ringField,action){  
  if(action == 'open'){
    $(".tps-ring-field-"+ringField).addClass('tps-popup-info-show');    
  }else{
    $(".tps-ring-field-"+ringField).removeClass('tps-popup-info-show');    
  }  
}
/**** Tooltip Information Open/Close End ****/ 